<template>
  <div class="remittance-info">
    <div class="remittance-info-title">{{ $t('汇款账户信息') }}</div>
    <div class="remittance-detail">
      <div class="remittance-item-wrapper">
        <div class="remittance-info-item">
          <span>{{ $t('收款户名') }}</span>
          <span>{{ bankPayInfo.companyName || '--' }}</span>
        </div>
        <div class="remittance-info-item">
          <span>{{ $t('收款银行') }}</span>
          <span>{{ bankPayInfo.bankName || '--' }}</span>
        </div>
        <div class="remittance-info-item">
          <span>{{ $t('汇款账号') }}</span>
          <span>{{ bankPayInfo.bankAccountNo || '--' }}</span>
        </div>
      </div>
      <es-button
        class="copy-account-info"
        theme="primary"
        variant="outline"
        icon="es-icon-copy"
        v-clipboard:success="copySuccess"
        v-clipboard:copy="copyValue"
        :key="copyValue"
        v-if="!loadingStatus">
        {{ $t('复制账户信息') }}
      </es-button>
    </div>
  </div>
</template>

<script>
import { $t } from '@/locales'
export default {
  name: 'RemittanceInfoCard',
  props: {
    bankPayInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    loadingStatus: {
      type: Boolean,
      default: true,
    },
    payAmountDisplay: {
      type: String,
      default: '0.00',
    },
  },
  data() {
    return {
    }
  },
  computed: {
    copyValue() {
      return `
          ${$t('收款户名：')}${this.bankPayInfo?.companyName}
          ${$t('收款银行：')}${this.bankPayInfo?.bankName}
          ${$t('汇款账号：')}${this.bankPayInfo?.bankAccountNo}
          ${$t('付款金额：')}${this.payAmountDisplay || '0.00'}${$t('元')}
        `
    },
  },
  methods: {
    copySuccess() {
      this.$message.success(this.$t('账户信息复制成功'))
    },
  },
}
</script>

<style lang="less" scoped>
.remittance-info {
  padding: 24px 20px;
  background: #fff;
  border-radius: 8px;
  &-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #000;
    margin-bottom: 24px;
  }
}
.remittance-detail {
  display: flex;
  justify-content: space-between;
  .remittance-info-item {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    span {
      display: inline-block;
      &:first-child {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666;
        width: 102px;
        flex-shrink: 0;
      }
      &:nth-child(2) {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }
    }
  }
  .remittance-item-wrapper {
    flex: 1;
    flex-shrink: 1;
    overflow: hidden;
    padding-right: 10px;
  }
  .copy-account-info {
    align-self: center;
    padding: 8px 10px;
    flex-shrink: 0;
  }
}
</style>
